/* eslint-disable */
/// This file is auto generated - do not edit manually
export const PersonalOffer = 'Website.Voucher.PersonalOffer';
export const BonusGift = 'Website.Voucher.BonusGift';
export const Advantage = 'Website.Voucher.Advantage';
export const Offer = 'Website.Voucher.Offer';
export const MatasPlus = 'Website.Voucher.MatasPlus';
export const Subscription = 'Website.Voucher.Subscription';
export const ShopNow = 'Website.Voucher.ShopNow';
export const ReadMore = 'Website.Voucher.ReadMore';
export const SpecialForYou = 'Website.Voucher.SpecialForYou';
export const MonthlyPlus = 'Website.Voucher.MonthlyPlus';
